import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Table, Thead, Tbody, Tr, Th, Td, ClickTr } from '../../../../components/Table/Fake';
import { Receipt } from '../../../../types/receipts';
import { getReceiptNetAmount, getReceiptStoreName } from '../../receiptHelpers';
import { DateTime } from '../../../../components/Formatters';

interface RowProps extends WithTranslation {
    row: Receipt;
    accountId: string;
    customerId: string;
    onClickRow: (accountId: string, id: string, receiptId: string) => void;
}


const Row = (
    {
        row,
        accountId,
        customerId,
        onClickRow,
        i18n,
    }: RowProps
) => {
    const lng = i18n.language;
    return (
        <ClickTr
            key={row.id}
            onClick={() => row.id ? onClickRow(accountId, customerId, row.id) : {}}
            className="stop-borders-before-edges"
        >
            <Td className="edge"/>
            <Td>{getReceiptStoreName(row)}</Td>
            <Td>
                <DateTime isoString={row.purchase_at || ''}/>
            </Td>
            <Td>{getReceiptNetAmount(row, lng)}</Td>
            <Td className="edge"/>
        </ClickTr>
    );
};

const TranslatedRow = withTranslation()(Row);

export interface CustomerTableProps extends WithTranslation {
    receipts: Receipt[];
    accountId: string;
    customerId: string;
    onClickRow: (accountId: string, id: string, receiptId: string) => void;
}

const CustomerTable = (
    {
        receipts,
        accountId,
        customerId,
        t,
        onClickRow,
    }: CustomerTableProps
) => {
    return (
        <Table className="no-wrap">
            <Thead>
                <Tr>
                    <Th className="edge"/>
                    <Th>{t('customers.customer.receipts.store')}</Th>
                    <Th>{t('customers.customer.receipts.purchase_date')}</Th>
                    <Th>{t('customers.customer.receipts.net_amount')}</Th>
                    <Th className="edge"/>
                </Tr>
            </Thead>
            {receipts.length > 0 && (
                <Tbody>
                    {receipts.map(tx => (
                        <TranslatedRow
                            onClickRow={onClickRow}
                            key={`${tx.id}`}
                            row={tx}
                            accountId={accountId}
                            customerId={customerId}
                        />
                    ))}
                </Tbody>
            )}
        </Table>
    );
};

export default withTranslation()(CustomerTable);
